export default "__VITE_ASSET__leSmCvh4__"